import React, { memo } from 'react';

import CollapseableFilter from './task-status';
import Divider from '@components/divider';

import style from './style.module.scss';

const StructureFilterGroups = ({
  structureTypeTags,
  picklistsMap,
  filters,
  updateFilters,
  structureStatusTags
}) => {
  return (
    <>
      <div className={style.filterHeader}>
        <p>Structure</p>
      </div>

      <section>
        <div>
          {structureTypeTags?.length > 0 && (
            <>
              <div className={style.filterRowContainer}>
                <CollapseableFilter
                  title={'Structure type'}
                  tags={structureTypeTags || []}
                  tagsMap={picklistsMap}
                  multi
                  value={filters?.structureType?.value}
                  onChange={(value) => updateFilters('structureType', 'value', value)}
                />
              </div>
              <Divider />
            </>
          )}
        </div>
        <div>
          {structureStatusTags?.length > 0 && (
            <>
              <div className={style.filterRowContainer}>
                <CollapseableFilter
                  title={'Structure status'}
                  tags={structureStatusTags || []}
                  tagsMap={picklistsMap}
                  multi
                  value={filters?.structureStatus?.value}
                  onChange={(value) => updateFilters('structureStatus', 'value', value)}
                />
              </div>
              <Divider />
            </>
          )}
        </div>
      </section>
    </>
  );
};

export default memo(StructureFilterGroups);
